import React from 'react';

/**
 * Spinner - A classic macOS-style loading spinner
 *
 * @param {number} size - The width and height of the spinner in pixels (default: 24)
 * @param {string} className - Additional CSS classes to apply
 *
 * Usage:
 * <Spinner size={24} className="my-custom-class" />
 */
const Spinner = ({ size = 24, className = '' }) => {
  const borderWidth = Math.max(1, Math.round(size / 8));

  return (
    <div
      className={`animate-spin ${className}`}
      style={{
        width: size,
        height: size,
        border: `${borderWidth}px solid #e5e7eb`,
        borderTop: `${borderWidth}px solid #004D5C`,
        borderRadius: '50%'
      }}
    />
  );
};

export default Spinner;
